import { Box, styled } from "@mui/material";

export const WizardRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

export const ContentArea = styled(Box)`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

export const SidebarPanel = styled(Box)`
  width: 475px;
  min-width: 475px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${({ theme }) => theme.palette.divider};
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  background-color: ${({ theme }) => theme.palette.background.paper};
  overflow: auto;
`;

export const MainPanel = styled(Box)`
  flex: 1;
  display: flex;
  overflow: hidden;
  position: relative;
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  background-color: ${({ theme }) => theme.palette.background.paper};
`;

export const ExplainerContent = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: ${({ theme }) => theme.spacing(4)};
  max-width: 600px;
  margin: 0 auto;
`;

export const CenteredOverlay = styled(Box)`
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
`;

export const MapPlaceIndicator = styled(Box)`
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: ${({ theme }) => `${theme.spacing(0.5)} ${theme.spacing(2)}`};
  border-radius: ${({ theme }) => theme.spacing(1)};
  font-size: 0.875rem;
  pointer-events: none;
  z-index: 1;
`;

export const MapContainer = styled(Box)`
  flex: 1;
  min-width: 0;
  position: relative;

  & .mapboxgl-ctrl-top-right {
    display: block !important;
  }
`;

export const FooterActions = styled(Box)`
  padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(3)}`};
`;
